// extracted by mini-css-extract-plugin
export default {"facilitiesContainer":"Home_facilitiesContainer__C29Bt"};